var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "separated-date-time text-body06-regular" }, [
    _c("div", { staticClass: "date-time-wrapper" }, [
      _c("label", { staticClass: "date-time-label" }, [
        _vm._v(_vm._s(_vm.$t("message.pickUpDate"))),
      ]),
      _c("div", { staticClass: "date-time-row" }, [
        _c(
          "div",
          {
            staticClass: "separated-date-time-symbol",
            attrs: {
              "data-target": _vm.targetDate,
              "data-toggle": _vm.targetDate,
            },
          },
          [
            _c("img", {
              staticClass: "separated-date-icon",
              attrs: { src: require("@/assets/icon/v3/date.svg"), alt: "cal" },
            }),
          ]
        ),
        _c("input", {
          ref: "dateRef",
          staticClass: "separated-date-input",
          attrs: {
            type: "text",
            placeholder: _vm.datelabel,
            "data-target": _vm.targetDate,
            readonly: "",
          },
        }),
      ]),
    ]),
    _c("div", { staticClass: "date-time-wrapper" }, [
      _c("label", { staticClass: "date-time-label" }, [
        _vm._v(_vm._s(_vm.$t("message.pickUpTime"))),
      ]),
      _c("div", { staticClass: "date-time-row-time" }, [
        _c(
          "div",
          {
            staticClass: "separated-date-time-symbol",
            attrs: {
              "data-target": _vm.targetTime,
              "data-toggle": _vm.targetTime,
            },
          },
          [
            _c("img", {
              staticClass: "separated-time-icon",
              attrs: {
                src: require("@/assets/icon/v3/time.svg"),
                alt: "clock",
              },
            }),
          ]
        ),
        _c("input", {
          ref: "timeRef",
          staticClass: "separated-time-input",
          attrs: {
            type: "text",
            placeholder: _vm.timelabel,
            "data-target": _vm.targetTime,
            readonly: "",
          },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }